/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { marketingPreferencesPostRequestSchema } from './marketingPreferencesPostRequestSchema.ts';
import { marketingPreferencesPostResponseSchema } from './marketingPreferencesPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postMarketingPreferences200Schema = z.lazy(() => marketingPreferencesPostResponseSchema);

/**
 * @description 505 response
 */
export const postMarketingPreferences505Schema = z.any();

export const postMarketingPreferencesMutationRequestSchema = z.lazy(() => marketingPreferencesPostRequestSchema);

export const postMarketingPreferencesMutationResponseSchema = z.lazy(() => postMarketingPreferences200Schema);
